
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/developers",
      function () {
        return require("private-next-pages/for/developers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for/developers"])
      });
    }
  